import { useState, useEffect } from 'react'

import { getChecklistNewStatusAPI } from '../services/checklist'

function UseChecklistStatus() {
  const [data, setData] = useState([])
  useEffect(() => {
    const getOrganization = async () => {
      const result = await getChecklistNewStatusAPI()
      if (!result) return

      const newData = [
        { value: "", label: "All" }, 
        ...result.result.map((d, i) => ({ value: d.id, label: d.status_en })),
      ];
      setData(newData)
    }
    getOrganization()
  }, [])

  return data
}

export default UseChecklistStatus
